// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"ce74f758","334":"596dac26","349":"f7f5b05a","585":"dee2ea45","615":"c45c3617","770":"03bc0149","923":"7aadfad3"}[chunkId] + ".chunk.js";
};